module.exports = __webpack_public_path__ + "img/WEB.16678a67.svg";